import nicknameInput from './nickname-input.vue'
export type { NicknameInputProps } from './props'
export default nicknameInput